import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'external-service-provider-countries' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
